import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { useScrollSelector, useAtTop } from '@gluedigital/scrollastic'

import './Header.sass'

export const Header = (props) => {

  const activeClass = useScrollSelector('.section', { boundary: '50px' })
  const topClass = useAtTop() ? ' top' : ''

  return (
    <header id="masthead" className={props.pageName + ' ' + activeClass + topClass}>
      <nav className="container" id="navigation">
        <Link className="logo" to="/" />
        <div className="links">
          <Link className="link link-intro" to="/#intro">
            <FormattedMessage id="header.intro" />
          </Link>
          <Link className="link link-features" to="/#features">
            <FormattedMessage id="header.features" />
          </Link>
          <Link className="link link-cases" to="/#cases">
            <FormattedMessage id="header.cases" />
          </Link>
          <Link className="link link-clients" to="/#clients">
            <FormattedMessage id="header.clients" />
          </Link>
        </div>
      </nav>
    </header>
  )
}

Header.propTypes = {
  pageName: PropTypes.string
}

export default Header
